import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import DataCenter from './DataCenter';

const DataCenters = ({ dataCenters }) => (
  <Container style={{ padding: 0 }}>
    {dataCenters.map(dataCenter => (
      <Row key={dataCenter.name}>
        <Col style={{ marginBottom: 10, textAlign: 'left' }}>
          <DataCenter {...dataCenter} />
        </Col>
      </Row>
    ))}
  </Container>
);

export default DataCenters;
